import type { LastAction } from '../types.js';

export interface LeaderInputs {
  readonly lastResult: { readonly winnerSeats: readonly number[] } | null;
  readonly lastAction: LastAction | null;
  readonly consecutivePasses: number;
  readonly leaderSeat: number;
  readonly playerCount: number;
}

/**
 * Seat that played the hand's last tile. A рыба is only detected on a pass,
 * and every pass since the last play came from the seats right before the
 * final passer, so the last player sits `consecutivePasses` seats back.
 */
function lastTilePlayer(input: LeaderInputs): number | null {
  const { lastAction, consecutivePasses, playerCount } = input;
  if (lastAction === null) return null;
  if (lastAction.kind === 'play') return lastAction.seat;
  if (lastAction.kind !== 'pass' || consecutivePasses >= playerCount) return null;
  return (lastAction.seat - consecutivePasses + playerCount) % playerCount;
}

/**
 * `nextHandLeader: 'winner'` leader: the previous hand's winner. A Козёл
 * «яйца» hand has no winner, so the seat that played its last tile leads;
 * the previous leader is the last-resort fallback.
 */
export function winnerLeader(input: LeaderInputs): number {
  return input.lastResult?.winnerSeats[0] ?? lastTilePlayer(input) ?? input.leaderSeat;
}
